import config from "../utils/constant";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useEffect, useContext } from "react";
import { AppContext } from "../store";
import { customerUrl } from "../utils/constant";
import cookie from "js-cookie"
import { error } from "console";

const TestLink = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const navigate = useNavigate();
  const { setLoginState } = useContext(AppContext);

  useEffect(() => {
    if (process.env.REACT_APP_APP_ENV === "prod") {
      navigate("/");
    }
    // router.query.email
    const url = config.API_ENDPOINT + "/users/login/email/" + email;
    localStorage.removeItem("authToken");
    cookie.remove("token")
    
    // refetch the token
    console.log("testlink login fetch token");
    setLoginState({
      status: "fetching",
      token: null,
    })
    if (email) {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const authToken = res?.data?.token;
          localStorage.removeItem('selectedAddressKey');
          console.log("resp data", res);
          if (authToken) {
            fetch(customerUrl, {
              method: "GET",
              headers: {
                Authorization: authToken,
              },
            })
              .then((res) => res.json())
              .then((res) => {
                if (res.status === 'success') {
                  console.log("customer data", res.data);
                  const loginState = {
                    status: "login",
                    token: authToken,
                    user: res.data,
                  };
                  console.log("set authToken", authToken);
                  localStorage.setItem('authToken', authToken)
                  cookie.set("token", authToken, {
                    secure: true, 
                    sameSite: "strict"
                  })
                  setLoginState(loginState);
                  navigate("/349", { replace: true });
                } else {
                  setLoginState({
                      status: "failed",
                      token: null,
                      user: null,
                  });
                  cookie.remove("token")
                }
              })
              .catch((e) => {
                console.log("errr", e);
                setLoginState({
                    status: "failed",
                    token: null,
                    user: null,
                });
              });
          } else {
            setLoginState({
                status: "failed",
                token: null,
                user: null,
            });
          }
        })
        .catch((e) => {
          console.log("errr", e);
          setLoginState({
              status: "failed",
              token: null,
              user: null,
          });
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
  return <div></div>;
};

export default TestLink;
